import React from 'react'

// Components
import * as StatFields from '../components/Global/ReduxForms/StatFields'

// --- Define which field type to use for each stat ---
const fieldTypeDeclarations = {}

fieldTypeDeclarations["Baseball"] = {
  "Hitting": {
    "Batting Average": StatFields.baseballAverage,
    "Slugging Percentage": StatFields.baseballAverage
  },
  "Pitching": {
    "Earned Run Average": StatFields.ERA,
    "Innings Pitched": StatFields.inningsPitched
  }
}

fieldTypeDeclarations["Softball"] = {
  "Hitting": {
    "Batting Average": StatFields.baseballAverage,
    "Slugging Percentage": StatFields.baseballAverage
  },
  "Pitching": {
    "Earned Run Average": StatFields.ERA,
    "Innings Pitched": StatFields.inningsPitched
  }
}

fieldTypeDeclarations["Basketball"] = {
  "Basketball": {
    "Field Goals Attempted / Field Goals Made": StatFields.ratio,
    "3-point Field Goals Attempted / 3-point Field Goals Made": StatFields.ratio,
    "Free throws attempted / Free throws made": StatFields.ratio
  }
}

fieldTypeDeclarations["Cross Country"] = {
  "Cross Country": {
    "Distance": StatFields.distanceMeters,
    "Time": StatFields.finishTime
  }
}

fieldTypeDeclarations["Football"] = {
  "QB Passing": {
    "Completion Percentage": StatFields.percentage
  },
  "Field Goals": {
    "Distances": StatFields.fieldGoalDistances
  }
}

fieldTypeDeclarations["Soccer"] = {
  "Offense": {
    "Penalty Goals / Penalty Attempts": StatFields.ratio,
  }
}

fieldTypeDeclarations["Hockey"] = {
  "Penalties": {
    "Penalty Minutes": StatFields.penaltyTime
  }
}

fieldTypeDeclarations["Swimming and Diving"] = {
  "50 Freestyle": {
    "Time": StatFields.finishTime
  },
  "100 Freestyle": {
    "Time": StatFields.finishTime
  },
  "200 Freestyle": {
    "Time": StatFields.finishTime
  },
  "400 Freestyle": {
    "Time": StatFields.finishTime
  },
  "500 Freestyle": {
    "Time": StatFields.finishTime
  },
  "50 Butterfly": {
    "Time": StatFields.finishTime
  },
  "100 Breaststroke": {
    "Time": StatFields.finishTime
  },
  "100 Backstroke": {
    "Time": StatFields.finishTime
  },
  "200 Individual Medley": {
    "Time": StatFields.finishTime
  },
  "200 Medley Relay": {
    "Split Time": StatFields.finishTime,
    "Stroke Swam": StatFields.text
  },
  "200 Freestyle Relay": {
    "Split Time": StatFields.finishTime
  },
  "400 Freestyle Relay": {
    "Split Time": StatFields.finishTime
  }
}

fieldTypeDeclarations["Tennis"] = {
  "Singles": {
    "Set Score": StatFields.setScore
  },
  "Doubles": {
    "Set Score": StatFields.setScore
  }
}

fieldTypeDeclarations["Track & Field"] = {
  "100 Meter": {
    "Time": StatFields.finishTime
  },
  "200 Meter": {
    "Time": StatFields.finishTime
  },
  "400 Meter": {
    "Time": StatFields.finishTime
  },
  "800 Meter": {
    "Time": StatFields.finishTime
  },
  "1600 Meter": {
    "Time": StatFields.finishTime
  },
  "3200 Meter": {
    "Time": StatFields.finishTime
  },
  "110 Meter Hurdles": {
    "Time": StatFields.finishTime
  },
  "300 Meter Hurdles": {
    "Time": StatFields.finishTime
  },
  "4 x 100 Meter Relay": {
    "Split Time": StatFields.finishTime
  },
  "4 x 200 Meter Relay": {
    "Split Time": StatFields.finishTime
  },
  "4 x 400 Meter Relay": {
    "Split Time": StatFields.finishTime
  },
  "4 x 800 Meter Relay": {
    "Split Time": StatFields.finishTime
  },
  "4 x 1600 Meter Relay": {
    "Split Time": StatFields.finishTime
  },
  "Sprint Medley Relay": {
    "Split Time": StatFields.finishTime,
    "Distance": StatFields.distanceMeters
  },
  "Distance Medley Relay": {
    "Split Time": StatFields.finishTime,
    "Distance": StatFields.distanceMeters
  },
  "4 X 110 Meter Hurdles Relay": {
    "Split Time": StatFields.finishTime
  },
  "Shot Put": {
    "Distance": StatFields.feetAndInches
  },
  "Discus Throw": {
    "Distance": StatFields.feetAndInches
  },
  "High Jump": {
    "Height": StatFields.feetAndInches
  },
  "Pole Vault": {
    "Height": StatFields.feetAndInches
  },
  "Long Jump": {
    "Distance": StatFields.feetAndInches
  },
  "5000 Meter": {
    "Time": StatFields.finishTime
  },
  "3000 Meter": {
    "Time": StatFields.finishTime
  },
  "3000 Meter Steeplechase": {
    "Time": StatFields.finishTime
  },
  "2000 Meter Steeplechase": {
    "Time": StatFields.finishTime
  },
  "400 Meter Hurdles": {
    "Time": StatFields.finishTime
  },
  "Hammer Throw": {
    "Distance": StatFields.feetAndInches
  },
  "Javelin": {
    "Distance": StatFields.feetAndInches
  },
}

fieldTypeDeclarations["Volleyball"] = {
  "Volleyball": {
    "Sets Played - Matches Played - Matches Started": StatFields.volleyballPlayedAndStarted,
  }
}

fieldTypeDeclarations["Field Hockey"] = {
  "Goalie": {
    "Win/Loss": StatFields.winLoss
  }
}

fieldTypeDeclarations["Ice Hockey"] = {
  "Penalties": {
    "Penalty Minutes": StatFields.penaltyTime
  }
}

// --- Export helper function ---
const StatField = (sportName, statCategory, statName, field, index, fields) => {
  const sportFields = fieldTypeDeclarations[sportName]
  const category = sportFields && sportFields[statCategory]
  const fieldType = category && category[statName]

  // Allow for custom field types but default to number
  const Field = fieldType || StatFields.number

  return <Field field={field} index={index} fields={fields} />
}

export default StatField



// WEBPACK FOOTER //
// ./src/utils/StatField.js